import {
  chakra,
  Code,
  Divider,
  Heading,
  Image,
  Link,
  ListItem,
  OrderedList,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  UnorderedList,
} from "@chakra-ui/react";
import * as React from "react";
import Markdown, { Components } from "react-markdown";
import remarkGfm from "remark-gfm";

const mb = {
  sx: {
    "&:not(:last-child)": {
      mb: 2,
    },
  },
};

type Props = {
  value?: string | null;
  size?: "xs" | "sm" | "md";
  inlineCodeBlocks?: boolean;
};

export const chakraComponents = ({ size, inlineCodeBlocks }: Props) =>
  ({
    p: ({ children }) => <Text {...mb}>{children}</Text>,
    em: ({ children }) => <Text as="em">{children}</Text>,
    blockquote: (props) => <Code as="blockquote" p={2} {...mb} {...props} />,
    code: (props) => (
      <Code
        borderRadius="base"
        display={inlineCodeBlocks ? "inline-block" : "block"}
        fontSize="xs"
        px={2}
        py={1}
        w={inlineCodeBlocks ? undefined : "full"}
        whiteSpace="break-spaces"
        {...mb}
        {...props}
      />
    ),
    del: ({ children }) => <Text as="del">{children}</Text>,
    hr: Divider,
    a: Link,
    img: Image,
    text: ({ children }) => <Text as="span">{children}</Text>,
    ul: (props) => <UnorderedList {...mb} {...props} />,
    ol: (props) => <OrderedList {...mb} {...props} />,
    li: (props) => <ListItem {...mb} {...props} />,
    h1: (props) => <Heading as="h1" {...props} />,
    h2: (props) => <Heading as="h2" {...props} />,
    h3: (props) => <Heading as="h3" {...props} />,
    h4: (props) => <Heading as="h4" {...props} />,
    h5: (props) => <Heading as="h5" {...props} />,
    h6: (props) => <Heading as="h6" {...props} />,
    pre: (props) => <chakra.pre {...mb} {...props} />,
    table: (props) => <Table size={size} {...mb} {...props} />,
    thead: Thead,
    tbody: Tbody,
    tr: Tr,
    td: Td,
    th: Th,
  }) satisfies Components;

export function MarkdownDisplay({ value, ...rest }: Props) {
  return (
    <Markdown
      components={chakraComponents(rest)}
      remarkPlugins={[remarkGfm]}
      skipHtml
    >
      {value}
    </Markdown>
  );
}
